import object from '@mailobj-browser/front/js/utils/object.js'

const block = 'ea_auth'

export const elements = object(null, {
  guardianship_features: `${block}__guardianship_features`,
  guardianship_feature: `${block}__guardianship_feature`,
  guardianship_feature_select_all: `${block}__guardianship_feature_select_all`,
  guardianship_feature_unselect_all: `${block}__guardianship_feature_unselect_all`,
  guardianship_feature_activated: `${block}__guardianship_feature_activated`,
  guardianship_feature_activation: `${block}__guardianship_feature_activation`
})